// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18gRJ","rootMobile":"styles_rootMobile__3P77S"};